import { ChevronDown } from "lucide-react";

export default function BannerPolitica() {
    const isSmallScreen = window.innerWidth < 640;

    function scroll(id) {
        const element = document.getElementById(id);
        element.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    return (
        <div className="h-[161px] md:h-screen bg-[url('../assets/banner_politica.png')] bg-no-repeat bg-cover bg-center flex flex-col items-center justify-center p-4 relative md:static">
            <h1 className="text-xl md:text-[60px] text-white text-center">
                <strong className=" font-raleway_bold">Política de privacidade<br/>Projectiva</strong>
            </h1>
            <button
                onClick={() => {
                    if (!isSmallScreen) {
                        scroll("politica");
                    }
                }}
                className="h-10 md:h-16 w-5 md:w-8 border-white border-1 md:border-2 text-white rounded-full flex items-center justify-center mt-4 md:mt-16 cursor-pointer"
            >
                <div className="animate-bounce ">
                    <ChevronDown size={!isSmallScreen ? 24 : 18} />
                </div>
            </button>
        </div>
    );
}
